var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconExitFullscreen = function SvgIconExitFullscreen(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 54,
    viewBox: "0 0 53 54",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    transform: "translate(-323.000000, -841.000000) translate(323.527988, 841.763994)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.472,
    height: 52.472,
    rx: 26.236
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.19
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 11L7 11 7 17M17 7L11 7 11 1M11 7L18 0M0 18L7 11",
    transform: "translate(-323.000000, -841.000000) translate(323.527988, 841.763994) translate(17.472012, 17.236006)"
  })))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconExitFullscreen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-exit-fullscreen.ca7531babe6dccaec5aecb04555a8b30.svg";